export default __webpack_public_path__ + "4c761b3711973ab04edf7ea6f1fbacdc.ttf";